import React from 'react'
import { useState, useEffect } from 'react';
import ProductGrid4 from '../../components/public/pages/home/productGrid4';
import InfiniteScroll from 'react-infinite-scroll-component';
import HomeFunctions from '../../functions/public/home';
import DocumentMeta from 'react-document-meta';

const KaayCloset = () => {
    const [products,setProducts] = useState([]);
    const [page, setPage] = useState(0);
    const [HasMore, setHasMore] = useState(true);
    const [collection,setCollection] = useState({
      id : 0,
      title:"Kaay Closet",
      discription:""
    });
    const getmore = ()=>{
      HomeFunctions.Kaayclosetpage(page,setPage,products,setProducts,setHasMore);
    }
    useEffect(() => {
      HomeFunctions.Kaayclosetpage(page,setPage,products,setProducts,setHasMore);
    },[])
    const meta = {
      title: 'Preloved Clothes & Products | Buy & Sell Second Hand Items online | KAAY',
      description: "Get the best deals on preloved, SecondHand Clothes & products at our online second-hand store. Buy & Sell used items at KAAY & discover the best second-hand shopping experience around. With fast shipping and unbeatable prices, you won't find a better deal anywhere else",
      canonical: window.location.href
      /*canonical: 'http://example.com/path/to/page',
      meta: {
          charset: 'utf-8',
          name: {
              keywords: 'react,meta,document,html,tags'
          }
      }*/
    }
  return (
    <div>
    <DocumentMeta {...meta} />
        <div style={{ margin:"0px 40px"}}>
            <div className='collection_heading'>
                <h3>{collection.title}</h3>
                <p>{collection.discription}</p>
            </div>
            <InfiniteScroll 
                dataLength={products.length}
                next={getmore}
                hasMore={HasMore}
                loader={<h1></h1>}
            >
              <ProductGrid4 Products={products} Columns={5}/>
            </InfiniteScroll>
        </div>
    </div>
  )
}

export default KaayCloset
